/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import { Outlet } from 'react-router-dom';
import { useSelector } from "react-redux";

/**
 * שכבה שמחכה להגדרות הריסיילר, ו**אינה מפנה לשום מקום**.
 *
 * זה ההבדל בינה לבין `RedirectByReseller`, ולכן הן שתיים: שם ההמתנה היא הקדמה
 * להכרעה - איזה מסך התחברות נפתח - וכאן אין מה להכריע. המסכים שתחתיה הם ההמשך של
 * התחברות שכבר התחילה: אימות דו-שלבי, בחירת שיטה אחרת, ורישום שיטה שנדרשת. לשלוח
 * אותם למסך ההתחברות לפי ערכת העיצוב היה מחזיר את הלקוח לתחילת התהליך שהוא בדיוק
 * באמצעו.
 *
 * **תמונה שנכשלה פותחת את המסך.** ההגדרות כאן הן עיצוב, לוגו ואם להציע פעולה - ולא
 * הרשאה; השערים האמיתיים בשרת ואינם תלויים במה שנטען כאן. ספינר שנשאר עד שהבקשה
 * תצליח היה לוכד לקוח שהסיסמה שלו כבר אושרה ורק הקוד חסר, כלומר במקום שאין ממנו
 * דרך אחורה. זו אותה נפילה לאחור של `AllowFeatureByReseller`.
 */
const RequireReseller = () => {
    const status = useSelector((state) => state.reseller.status);
    const reseller = useSelector((state) => state.reseller.value);

    if (status === "failed") {
        return <Outlet />;
    }

    if (status !== "succeeded" || !reseller || !reseller.hasOwnProperty("code")) {
        return <div className="loader-container"><div className="loader"></div></div>;
    }

    return <Outlet />;
};

export default RequireReseller;
